export default __webpack_public_path__ + "static/media/hamburger.fab2060d.svg";